module.exports = __webpack_public_path__ + "img/background.fd1b9953.png";